import { Typography, Box } from "@mui/material";
import { useAppContext } from "../../context/appContext";
import moment from "moment";
import "moment/locale/de";

import { ChatAppTitle } from "../../../3_apps/6_ChatApp/ChatAppComponents/ChatAppPageTitle.js/ChatAppTitle";
import { HusibuechAppTitle } from "../../../3_apps/5_Husibuech/HusibuechAppPageTitle/HusibuechAppTitle";
import { GatterAppTitle } from "../../../3_apps/7_GatterApp/GatterAppComponents/GatterAppPageTitle.js/GatterAppTitle";
import { EventManagerTitle } from "../../../3_apps/3_EventManagerApp/components/header/EventManagerTitle";
import { ProfileTitle } from "../../1_KsbPages/ProfilePage/ProfileComponents/ProfileTitle";
import { SondertagTitle } from "../../../3_apps/4_SondertageApp/components/SondertagTitle";
import { AdminTitle } from "../../1_KsbPages/AdminPage/components/AdminTitle";
import { BSZFinderTitle } from "../../../3_apps/1_BSZFinderApp/components/appTitle/BSZFinderTitle";
import { BSZPlannerTitle } from "../../../3_apps/2_BSZPlannerApp/appTitle/BSZPlannerTitle";
import { AskomaTitle } from "../../../3_apps/8_AskomaApp/components/appTitle/AskomaTitle";

moment.locale("de");

export const LeftBox = ({ type }) => {
  const { isMobile, isSmallScreen, referenceDate } = useAppContext();

  const titleMap = {
    bszPlanner: <BSZPlannerTitle />,
    bszFinder: <BSZFinderTitle />,
    chatApp: <ChatAppTitle />,
    sondertageApp: <SondertagTitle />,
    eventManagerApp: <EventManagerTitle />,
    gatterApp: <GatterAppTitle />,
    husibuech: <HusibuechAppTitle />,
    profile: <ProfileTitle />,
    admin: <AdminTitle />,
    askoma: <AskomaTitle />,
  };

  const defaultContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "row" : "column",
        alignItems: isMobile ? "flex-end" : "flex-start", // ✅ bottom align (same pattern)
        gap: isMobile ? 1 : 0,
        whiteSpace: "nowrap",
      }}
    >
      {/* ✅ Desktop only */}
      {!isMobile ? (
        <Typography variant="h6" color="primary">
          Willkommen
        </Typography>
      ) : (
        <Typography variant="h6" color="primary">
          Unsere Apps
        </Typography>
      )}

      {/* ✅ Date */}
      {!isMobile && (
        <Typography
          color="primary"
          variant={isMobile ? "h6" : "h4"}
          fontWeight="bold"
        >
          {moment(referenceDate).format(isSmallScreen ? "DD.MM." : "DD. MMMM")}
        </Typography>
      )}
    </Box>
  );

  return (
    <Box
      sx={{
        flex: 1,
        textAlign: "start",
        whiteSpace: "nowrap",
      }}
    >
      {titleMap[type] ?? defaultContent}
    </Box>
  );
};
